import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import exportFromJSON from "export-from-json";
import { AvForm, AvField } from "availity-reactstrap-validation";

import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Container,
  Button,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";

import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
} from "react-bootstrap-table2-toolkit";

import { postSubmitForm } from "../../../../helpers/forms_helper";
import moment from "moment";

import preloader from "../../../../helpers/preloader";
import showNotification from "../../../../helpers/show_notification";
import { MapAllObjectUnits,  MapTotalForArrangement, MapUnitForArrangement } from "../../../../helpers/units";
import printDiv from "../../../../helpers/print_data";


const ItemArrangementReport = (props) => {


  const columns = [
    { dataField: "item", hidden: true },
    { dataField: "item", text: "Product Name",sort:true },
    { dataField: "category", text: "Category" },
    { dataField: "sub_category", text: "Sub Category" },
    { dataField:"value",
      text: "Quantity",
      formatter: (cell, row, rowIndex) => {
        return row.value+" "+row.unit
      },
    },
    // {
    //   text: "Quantity",
    //   formatter: (cell, row) => {
    //     return ExportAvailableInCSVForReports(row.quantity)
    //   },
    // },
  ];

  useEffect(() => {
    loadAllTimeStamps();
  }, []);
  const [allTimeStamps, setAllTimeStamps] = useState([]);
  const [selectedTimestamp, setSelectedTimestamp] = useState();
  const loadAllTimeStamps = async () => {
    let url =
      process.env.REACT_APP_BASEURL + "itemorders/get_arrangement_marks";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllTimeStamps(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };
  useEffect(() => {
    loadItems();
  }, [selectedTimestamp]);
  const [data1, setData1] = useState([]);
  const [arrData, setArrData] = useState([]);

  const loadItems = async () => {
    preloader(true);
    let data_to_send = {
      mark_time:
        selectedTimestamp && selectedTimestamp !== ""
          ? selectedTimestamp
          : null,
    };

    let url =
      process.env.REACT_APP_BASEURL + "itemorders/arrangement_report";
    const response = await postSubmitForm(url, data_to_send);

    if (response && response.status === 1 && response.data) {
      setArrData(response.data);
    } else {
      showNotification(response.message, "Error");
    }
    let url1 =
      process.env.REACT_APP_BASEURL +
      "itemorders/arrangement_report_branchwise";
    const response1 = await postSubmitForm(url1, data_to_send);
    if (response1 && response1.status === 1) {
      setData1(response1.data);
    } else {
      showNotification(response1.message, "Error");
    }
    preloader(false);
  };

  const getColumns = (values) => {
    const columns = [
      { dataField: "_id", hidden: true },
      {
        dataField: "_id",
        formatter: (cell, row, rowIndex) => {
          return rowIndex + 1;
        },
        text: props.t("#"),
        headerStyle: (colum, colIndex) => {
          return { width: "50px" };
        },
      },
    ];

    for (let key in values[0]) {
      if( key === "Total"){
        columns.push({
          text: key,
          dataField: key,
          formatter: (cell, row, rowIndex) => {
            return ( MapTotalForArrangement(cell) );
          },
        });
      } else{
      if (key !== "Item Name") {
        columns.push({
          text: key,
          dataField: key,
          formatter: (cell, row, rowIndex) => {
            return ( MapAllObjectUnits(cell) );
          },
        });
      }else{
        columns.push({
          text: key,
          dataField: key,
        });
      }}
    }

    return columns;
  };

  const printReport = async () => {
    if (!selectedTimestamp) {
      let url =
        process.env.REACT_APP_BASEURL + "itemorders/mark_arrangement_report";
      let response = await postSubmitForm(url, "");
      if (response.status === 1) {
        loadAllTimeStamps();
        printPage();
      } else {
        showNotification(response.message, "Error");
      }
    } else {
      printPage()
    }
  };
  const handleDownload = async (divName) => {
    const fileName = "item_arrangement_report";
    const exportType = "xls";
    let alldata = [divName];
    let d3;
    let d = alldata.map((i) => {
      // console.log(i);
      return i.items;
    });

    let d1 = d.map((i) => {
      // console.log(i, "cfgfcg");
      return (d3 = i);
    });

    if (d3) {
      var data = [];
      JSON.parse(JSON.stringify(d3)).forEach(function (v) {
        // console.log(v);
        data.push({
          product: v.item,
          Category: v.category,
          SubCategory: v.sub_category,
          Quantity: v.value,
          Unit: v.unit,
          // Quantity: MapAllObjectUnits(v.quantity),
        });
      });

      exportFromJSON({ data, fileName, exportType });
    }
  };
  const handleDownload2 = async (divName) => {
    const fileName = "item_arrangement_report";
    const exportType = "xls";
    let alldata = [divName];

    let d = [];
    alldata.map((item1) => {
      item1.categories.map((item2) => {
        d = d.concat(item2.values);
      });
    });
    if (d) {
      var data = [];
      JSON.parse(JSON.stringify(d)).forEach(function (v) {
        let obj = {};
        let unitValue = '';
        for (let key in v) {
          if (key == "Item Name") {
            obj[key] = v[key];
          } else if (key != "_id") {
            obj[key] = MapAllObjectUnits(v[key]);
            unitValue = MapUnitForArrangement(v[key]);
          }
        }
        obj['Unit'] = unitValue;
        data.push(obj);
      });
      exportFromJSON({ data, fileName, exportType });
    }
  };

  function printPage() {
    const containerElement = document.getElementsByClassName("page-content")[0];
    const style = document.createElement("style");
    style.innerHTML = `
      .table thead th {
        color: #000 !important; 
        -webkit-print-color-adjust: exact; 
      }     
    `;
    document.head.appendChild(style);
    containerElement.scrollIntoView({ behavior: "smooth", block: "start" });
  
    setTimeout(() => {
      window.print();
      document.head.removeChild(style);
    }, 500);
  }

    const defaultSorted = [{
    dataField: 'item',
    order: 'asc'
  }];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Arrangement Report")}
            title={props.t("Reports")}
            breadcrumbItem1={props.t("Orders")}
            breadcrumbItem2={props.t("Arrangement Report")}
          />
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <AvForm>
                    <Row>
                      <Col lg={12}>
                        <AvField
                          name="timestamp"
                          label={props.t("Timestamp")}
                          value={selectedTimestamp}
                          type="select"
                          onChange={(e) => setSelectedTimestamp(e.target.value)}
                        >
                          <option value="">{props.t("Latest")}</option>
                          {allTimeStamps &&
                            allTimeStamps.map((e) => (
                              <option key={e._id} value={e.mark_time}>
                                {moment(e.mark_time).format("DD/MM/YYYY HH:mm")}
                              </option>
                            ))}
                        </AvField>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-print-none">
                    <div className="float-right">
                      <Link
                        to="#"
                        onClick={() => {
                          printReport();
                        }}
                        className="btn btn-success waves-effect waves-light mr-2"
                      >
                        <i className="fa fa-print"></i> Print Report
                      </Link>
                    </div>
                  </div>
                  <div id="printableArea">
                    <h3 className="text-center">Production Report</h3>
                    <hr />
                    {data1 &&
                      data1.map((category) => {
                        return (
                          <>
                            <div className="d-print-none">
                              <Link
                                to="#"
                                onClick={() => {
                                  printDiv(category.branch);
                                }}
                                className="btn btn-sm btn-success mr-2"
                              >
                                <i className="fa fa-print"></i> Print Branch
                              </Link>
                            </div>
                            <div className="float-right">
                              <Button
                                type="submit"
                                className="btn btn-sm btn-secondary d-print-none"
                                onClick={() => {
                                  handleDownload(category);
                                }}
                              >
                                <i className="mdi mdi-file-export"></i>{" "}
                                {props.t("Export CSV")}
                              </Button>
                            </div>
                            <div id={category.branch}>
                              <CardTitle className="for-print-heading">
                                {category.branch}
                              </CardTitle>

                              <ToolkitProvider
                                bootstrap4
                                keyField="item"
                                data={category.items}
                                columns={columns}
                                noDataIndication={props.t(
                                  "No data to display."
                                )}
                                search
                                exportCSV
                              >
                                {(props) => (
                                  <div>
                                    <BootstrapTable
                                      striped
                                      hover
                                      defaultSorted={defaultSorted}
                                    //  defaultSortDirection="asc"
                                      condensed
                                      {...props.baseProps}
                                    />
                                  </div>
                                )}
                              </ToolkitProvider>
                              <br />
                              <hr />
                            </div>
                          </>
                        );
                      })}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
          <Col className="col-12">
                <Card>
                  <CardBody>
                    {/* <div className="d-print-none">
                      <div className="float-right">
                        <Link
                          to="#"
                          onClick={() => {
                            printReport();
                          }}
                          className="btn btn-success waves-effect waves-light mr-2"
                        >
                          <i className="fa fa-print"></i> Print Report
                        </Link>
                      </div>
                    </div> */}
                    <div id="printableArea">
                      <h3 className="text-center">Arrangement Report</h3>
                      <hr />
                      {arrData &&
                        arrData.map((section) => {
                          return (
                            <>
                              <div className="d-print-none">
                                <Link
                                  to="#"
                                  onClick={() => {
                                    printDiv(section.category);
                                  }}
                                  className="btn btn-sm btn-success mr-2"
                                >
                                  <i className="fa fa-print"></i> Print Category
                                </Link>
                              </div>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-sm btn-secondary"
                                  onClick={() => {
                                    handleDownload2(section);
                                  }}
                                >
                                  <i className="mdi mdi-file-export"></i>
                                  {props.t("Export CSV")}
                                </Button>
                              </div>
                              <div id={section.category}>
                                <CardTitle className="for-print-heading">
                                  {section.category}
                                </CardTitle>

                                {section.categories.map((category) => {
                                  return (
                                    <>
                                      <div
                                        // style={{
                                        //   overflowX: "scroll",
                                        // }}
                                      >
                                        <ToolkitProvider
                                          bootstrap4
                                          keyField="_id"
                                          data={
                                            category.values && category.values
                                          }
                                          columns={getColumns(category.values)}
                                          noDataIndication={props.t(
                                            "No data to display."
                                          )}
                                          search
                                          exportCSV
                                        >
                                          {(props) => (
                                            <BootstrapTable
                                              striped
                                              hover
                                              // defaultSorted={defaultSorted}
                                              condensed
                                              {...props.baseProps}
                                            />
                                          )}
                                        </ToolkitProvider>
                                      </div>
                                      <br />
                                    </>
                                  );
                                })}
                                <hr />
                              </div>
                            </>
                          );
                        })}
                    </div>
                  </CardBody>
                </Card>
              </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemArrangementReport))
);
